import {Component, Input, OnInit} from '@angular/core';
import {SkeletonComponent} from "../../skeleton/skeleton.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-skeleton-message',
  templateUrl: './skeleton-messages.component.html',
  standalone: true,
  imports: [
    SkeletonComponent,
    NgIf
  ],
  styleUrls: ['./skeleton-messages.component.scss']
})
export class SkeletonMessagesComponent implements OnInit {

  @Input() mobile: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
